export const STYLED_TEXT = 'STYLED_TEXT';
export const STYLED_NUMBER = 'STYLED_NUMBER';
export const REACT_SELECT_INPUT = 'REACT_SELECT_INPUT';
export const BUTTON_SELECT_COMPONENT = 'BUTTON_SELECT_COMPONENT';
export const STYLED_PASSWORD = 'STYLED_PASSWORD';
export const CHECKBOX = 'CHECKBOX';
export const CHECKBOX_GROUP = 'CHECKBOX_GROUP';
export const MESSAGE = 'MESSAGE';
export const IMAGE_UPLOAD = 'IMAGE_UPLOAD';
export const IMAGE_PREVIEW = 'IMAGE_PREVIEW';
export const EXPANDABLE_IMAGE_COMPONENT = 'EXPANDABLE_IMAGE_COMPONENT';
export const FILE_UPLOAD = 'FILE_UPLOAD';
export const DATE_PICKER = 'DATE_PICKER';
export const VISITOR_DATE_PICKER = 'VISITOR_DATE_PICKER';
export const GEO = 'GEO';
export const PHONE_NUMBER = 'PHONE_NUMBER';
export const SPREADSHEET_UPLOAD = 'SPREADSHEET_UPLOAD';
export const DATE_TIME_PICKER = 'DATE_TIME_PICKER';
export const TIME_PICKER = 'TIME_PICKER';
export const SCHEDULE = 'SCHEDULE';
export const ONE_LINE_TEXT_FIELD = 'ONE_LINE_TEXT_FIELD';
export const PHONE_NUMBER_WITH_EXTENSION = 'PHONE_NUMBER_WITH_EXTENSION';
export const PHONE_NUMBER_WITH_VERIFICATION = 'PHONE_NUMBER_WITH_VERIFICATION';
export const CUSTOM_FIELD_COMPONENT = 'CUSTOM_FIELD_COMPONENT';
export const CUSTOM_PICKER_ROW = 'CUSTOM_PICKER_ROW';
export const STYLED_LINK = 'STYLED_LINK';
export const CHIP_TEXT_FIELD = 'CHIP_TEXT_FIELD';
export const MULTIPLE_TEXT_FIELDS = 'MULTIPLE_TEXT_FIELDS';
